const rtfcConfig = {
  highlightsJson: "./data/rtfc-highlights.json",
  autoconnectHighlights: [], //5242881, 5244525, 3166734, 4112246, 5244581],
};

const config = rtfcConfig;

export default config;
